import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PlanLimitError } from '@/lib/api'

/**
 * Ephemeral UI state.
 *
 * The upgrade modal lives here because it is opened by an axios interceptor —
 * a layer with no access to React context. Any 402 from anywhere in the app
 * surfaces the same modal without a single component knowing about it.
 */

type UiState = {
  sidebarCollapsed: boolean
  toggleSidebar: () => void

  upgradePrompt: { limit: string; current: number; max: number | null; message: string } | null
  openUpgradePrompt: (error: PlanLimitError) => void
  closeUpgradePrompt: () => void

  commandOpen: boolean
  setCommandOpen: (open: boolean) => void
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

      upgradePrompt: null,
      openUpgradePrompt: (error) =>
        set({
          upgradePrompt: {
            limit: error.limit,
            current: error.current,
            max: error.max,
            message: error.message,
          },
        }),
      closeUpgradePrompt: () => set({ upgradePrompt: null }),

      commandOpen: false,
      setCommandOpen: (commandOpen) => set({ commandOpen }),
    }),
    {
      name: 'voltra.ui',
      // Only the sidebar preference is worth remembering between sessions.
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed }),
    },
  ),
)
